import { PracticeWithAdmin } from '@hb/shared'
import { createContext, PropsWithChildren, useContext, useMemo, useState } from 'react'
import { usePractice } from '../../../hooks/backend/practice/usePractice'

interface TemplatePracticeTemplateContextData {
  practice: PracticeWithAdmin | null
  selectPractice: (practiceId: string) => void
  practiceId: string | null
  isLoading: boolean
}
const TemplatePracticeDataContext = createContext<TemplatePracticeTemplateContextData>({
  selectPractice: () => {},
  practiceId: null,
  practice: null,
  isLoading: false,
})
const useTemplatePracticeData = (templatePracticeId: string | null) => {
  const [manualPracticeId, setManualPracticeId] = useState<string | null>(null)
  // const { selectedPracticeId } = usePracticeAccess()
  const practiceId = useMemo(
    () => templatePracticeId ?? manualPracticeId,
    [templatePracticeId, manualPracticeId],
  )

  const { data: practice, loading: practiceLoading } = usePractice(practiceId)

  return useMemo(
    () => ({
      practiceId,
      selectPractice: templatePracticeId ? () => {} : setManualPracticeId,
      practice,
      isLoading: practiceLoading,
    }),
    [practiceId, practice, practiceLoading, templatePracticeId],
  )
}

export const TemplatePracticeDataProvider = ({
  children,
  templatePracticeId,
}: PropsWithChildren<{ templatePracticeId: string | null }>) => {
  const contextData = useTemplatePracticeData(templatePracticeId)
  return (
    <TemplatePracticeDataContext.Provider value={contextData}>
      {children}
    </TemplatePracticeDataContext.Provider>
  )
}

export const useTemplatePractice = () => useContext(TemplatePracticeDataContext)
